'use server';

import { SessionService } from '@/contexts/authentication';

import { locales } from '@/shared/i18n';

const VALID_LOCALES: readonly string[] = locales;

export async function updatePreferredLocale(locale: string): Promise<boolean> {
  try {
    const userId = await SessionService.getUserId();
    if (!userId) return false;

    if (!VALID_LOCALES.includes(locale)) return false;

    const { getMemberRepository } = await import(
      '@/contexts/family/core/repositories'
    );
    await getMemberRepository().update(userId, {
      preferredLocale: locale,
    } as any);

    return true;
  } catch {
    return false;
  }
}
